import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from '../token/interceptor';
import { SuficienciaCalificacionesService } from './suficienciaCalificaciones/suficienciaCalificaciones.service';
import { SuficienciaIdiomaService } from './suficienciaIdioma/suficienciaIdioma.service';
import { SuficienciaInformeService } from './suficienciaInforme/suficienciaInforme.service';
import { SuficienciaIntervalosCalificacionesService } from './suficienciaIntervalosCalificaciones/suficienciaIntervalosCalificaciones.service';
import { SuficienciaNivelHomologadoService } from './suficienciaNivelHomologado/suficienciaNivelHomologado.service';
import { SuficienciaUbicacionIdiomaService } from './suficienciaUbicacionIdioma/suficienciaUbicacionIdioma.service';
import { HabilidadesService } from './Habilidades/habilidades.service';
import { TipoHabilidadesService } from './TipoHabilidad/tipoHabilidades.service';
import { TipoRegistroUbicacionService } from './TipoRegistroUbicacion/tipoRegistroUbicacion.service';
import { NivelIntervaloCalificacionService } from './NivelIntervaloCalificacion/nivelIntervaloCalificacion.service';
import { TipoCertificadoService } from './tipoCertificado/tipoCertificado.service';
import { ProcesoService } from './proceso/proceso.service';
import { ConvocatoriaService } from './convocatoria/convocatoria.service';
import { NivelesConvalidacionService } from './nivelesConvalidacion/nivelesConvalidacion.service';
import { AsistenciaService } from './asistencia/asistencia.service';
import { ObservacionesUbicacionEstudianteService } from './observacionesUbicacionEstudiante/observacionesUbicacionEstudiante.service';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [],
  declarations: []
})
export class SharedIdiomasModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedIdiomasModule,
      providers: [
        SuficienciaCalificacionesService,
        SuficienciaIdiomaService,
        SuficienciaInformeService,
        SuficienciaIntervalosCalificacionesService,
        SuficienciaNivelHomologadoService,
        SuficienciaUbicacionIdiomaService,
        HabilidadesService,
        TipoHabilidadesService,
        NivelIntervaloCalificacionService,
        TipoRegistroUbicacionService,
        TipoCertificadoService,
        ProcesoService,
        ConvocatoriaService,
        NivelesConvalidacionService,
        AsistenciaService,
        ObservacionesUbicacionEstudianteService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }]
    };
  }
}
